import { ApolloClient, InMemoryCache, split, HttpLink } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { WebSocketLink } from '@apollo/client/link/ws';
require('dotenv').config()

const   token       = JSON.parse(localStorage.getItem('jwt')),
        protocol   = process.env.REACT_APP_MODE ? ['https://', 'wss://'] : ['http://', 'ws://'],
        selectPlc  = localStorage.getItem("gateway_selected")? localStorage.getItem("gateway_selected") : null

let httpLink = new HttpLink({
    uri: `${protocol[0] + process.env.REACT_APP_API_URL}/graphql`,
    headers:{
        token: token?token.token:null,
        gateway: selectPlc? selectPlc : null
     }
});

const wsLink = process.browser
    ? new WebSocketLink({
        uri: `${protocol[1] + process.env.REACT_APP_API_URL}/graphql`,
        options: {
            reconnect: true,
            connectionParams:{
                Authorization: "JWT",
            },
        },
    }): null;

const splitLink = process.browser
    ? split(
        ({ query }) => {
            const definition = getMainDefinition(query);
            return (
                definition.kind === "OperationDefinition" &&
                definition.operation === "subscription"
            );
        },
        wsLink,
        httpLink
    )
    : httpLink;

const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: splitLink,
    defaultOptions: {
        query: {
            fetchPolicy: "cache-and-network",
        },
        mutate:{
            fetchPolicy: "no-cache",
        },
    },

})

export default client